var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-window",attrs:{"id":"Usuario"}},[_c('div',{staticClass:"global-window-header"},[_c('h1',[_vm._v("Cadastro do Usuário")])]),_c('hr'),_c('div',{staticClass:"global-window-body"})])
}]

export { render, staticRenderFns }